module.exports = __webpack_public_path__ + "static/media/Icon 2.f5ede2ad.jpeg";